import MyCustomLogoIcon from '../Root/Logo/scania_symbol_L_rgb.png';

const LogoIcon = () => {
  return <img src={MyCustomLogoIcon} className="tegel-logo-icon" alt="Logo" />;
};

export default LogoIcon;
